<template>
  <div class="backdrop">
    <transition name="fade-scale" appear>
      <div v-if="show" class="ie-popup">
        <!-- <span class="closebtn pointer" @click="regionSelect"></span> -->
        <div class="ie-popup--inner">
          <h2 class="text-blue-p text-center pb-2xl">
            Welcome to MIS Implants
          </h2>
          <h4 class="text-center font-rg pb-xl">
            Please use a supported browser:
          </h4>
          <div class="browser-list text-center">
            <a href="https://www.mozilla.org/en-US/firefox/new/">
              <img src="/img/supported-browsers/firefox.png" alt="" />
              <span>Download Firefox</span>
            </a>
            <a href="https://www.google.com/chrome/">
              <img src="/img/supported-browsers/chrome.png" alt="" />
              <span>Download Chrome</span>
            </a>
            <a href="microsoft-edge:https://www.mis-implants.com">
              <img src="/img/supported-browsers/edge.png" alt="" />
              <span>Open with Edge</span>
            </a>
          </div>
          <div class="block pt-3xl text-center">
            <logo />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    };
  },
  mounted() {
    setTimeout(
      function() {
        this.show = true;
      }.bind(this),
      200
    );
  }
};
</script>

<style lang="stylus" scoped>
.backdrop
  position fixed 0 0 0 0
  background rgba(#fff, 0.99)
  z-index 99999999
.closebtn
  position absolute
  top 10px
  right 10px
  &:before
  &:after
    background blue_4
.ie-popup
  center()
  z-index 11
  width 95vw
  min-height 40vh
  max-width 900px
  padding 15vh 0 10vh
  background gray_0 url('/img/region-popup-bg.png') no-repeat 0 0 / cover
  box-shadow 0 0 8px rgba(gray_5,0.2)
  text-align center
  +below(600px)
    min-height 80vh
  a
    display inline-block
    text-align center
    margin 0 20px
    img
      width 110px
    span
      display block
      text-align center
    +below(600px)
      width 50%
      height 36px
      padding 0 30px
      border-radius 18px
      img
      i
        max-height 45%
        margin-right 10px
  .mis-logo
    max-height 50px
  h2
    font-size responsive 32px 46px
    text-transform uppercase
  h4
    font-size 24px
</style>
